import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../assets/logo.png';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Blog', to: '/blog' },
  { label: 'FAQs', to: '/faqs' },
];

const MARQUEE_ITEMS = [
  '⚡ Instant Loan Decisions',
  '🔒 Bank-Level Security',
  '💰 ₦2B+ Disbursed to Nigerians',
  '🔄 Group Ajo & Contribution Plans',
  '📊 Free Credit Reports',
  '⏱ Funds Disbursed in 24 Hours',
];

const SOCIAL_ICONS = [
  {
    label: 'Facebook',
    render: () => <path d="M13.5 21v-7.5h2.5l.5-3h-3V8.5c0-.9.3-1.5 1.6-1.5H16V4.2C15.7 4.2 14.7 4 13.6 4c-2.3 0-3.9 1.4-3.9 4v2.5H7v3h2.7V21h3.8z" />,
  },
  {
    label: 'X',
    render: () => <path d="M18.9 3H22l-7.2 8.2L23 21h-6.6l-5.2-6.4L5.2 21H2l7.7-8.8L1.5 3h6.8l4.7 5.9L18.9 3zm-1.2 16h1.8L7.4 5H5.5l12.2 14z" />,
  },
  {
    label: 'Instagram',
    render: () => (
      <g fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none" />
      </g>
    ),
  },
  {
    label: 'LinkedIn',
    render: () => <path d="M4.98 3.5a2.5 2.5 0 11-.02 5 2.5 2.5 0 01.02-5zM3.5 9h3v11.5h-3V9zM9.5 9h2.9v1.6h.04c.4-.76 1.4-1.6 2.9-1.6 3.1 0 3.7 2 3.7 4.7v6.8h-3v-6c0-1.4 0-3.3-2-3.3s-2.3 1.6-2.3 3.2v6.1h-3V9z" />,
  },
];

function HeaderMarquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="header-marquee-wrap">
      <div className="header-marquee">
        <div className="header-marquee-track">
          {items.map((text, i) => <span key={i}>{text}</span>)}
        </div>
      </div>
      <div className="header-marquee-social">
        {SOCIAL_ICONS.map(({ label, render }) => (
          <svg key={label} width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-label={label}>{render()}</svg>
        ))}
      </div>
    </div>
  );
}

export default function PublicNav() {
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Fragment>
      <HeaderMarquee />
      <nav className="landing-nav" style={{
      position: 'sticky', top: 0, zIndex: 100,
      background: 'var(--nav-bg)', backdropFilter: 'blur(20px)',
      borderBottom: '1px solid var(--border)',
      padding: '0 5%', height: 84,
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', flexShrink: 0 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="PCredit" style={{ height: 38, width: 'auto' }} />
        </Link>
      </div>

      <div className="landing-nav-right" style={{ display: 'flex', alignItems: 'center', gap: '2.25rem' }}>
        <button
          onClick={toggleTheme}
          style={{ background: 'var(--subtle-bg)', border: '1px solid var(--border-bright)', borderRadius: 8, padding: '0.45rem 0.65rem', color: 'var(--text-2)', cursor: 'pointer', fontSize: '0.9rem' }}
        >
          {theme === 'dark' ? '☀' : '🌙'}
        </button>

        <div className="landing-nav-links">
          {NAV_LINKS.map(({ label, to }) => (
            <Link key={label} to={to} className="landing-nav-link">{label}</Link>
          ))}
        </div>

        <div className="landing-nav-actions" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <Link to="/register" className="btn btn-primary" style={{ fontSize: '0.875rem', padding: '0.45rem 1.1rem' }}>Get Started</Link>
        </div>

        <button
          className="landing-nav-hamburger"
          onClick={() => setMenuOpen(o => !o)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className={menuOpen ? 'open' : ''} />
          <span className={menuOpen ? 'open' : ''} />
          <span className={menuOpen ? 'open' : ''} />
        </button>
      </div>
      </nav>

      <div className={`landing-nav-mobile-menu ${menuOpen ? 'open' : ''}`}>
        {NAV_LINKS.map(({ label, to }) => (
          <Link key={label} to={to} className="landing-nav-mobile-link" onClick={() => setMenuOpen(false)}>{label}</Link>
        ))}
      </div>
    </Fragment>
  );
}
